import { render, staticRenderFns } from "./MapaCatalunya.vue?vue&type=template&id=6049f7fc&scoped=true&"
import script from "./MapaCatalunya.vue?vue&type=script&lang=js&"
export * from "./MapaCatalunya.vue?vue&type=script&lang=js&"
import style0 from "./MapaCatalunya.vue?vue&type=style&index=0&id=6049f7fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6049f7fc",
  null
  
)

export default component.exports